import {
    ReportTableActionMenuTypesEnum,
    ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableData
} from 'appShared/components';

export const CryptoDepositAddressAccountIdSelector = 'account_reference_id';
export const CryptoDepositAddressAccountCurrencySelector = 'account_currency';
export const CryptoDepositAddressTypeSelector = 'type';
export const CryptoDepositAddressCurrencySelector = 'currency';
export const CryptoDepositAddressNetworkSelector = 'network';
export const CryptoDepositAddressDepositAddressSelector = 'deposit_address';

export const PanelClientsEditCryptoDepositAddressesDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: CryptoDepositAddressAccountIdSelector,
            value: null,
            hidden: false,
            class: 'crypto-deposit-account-id'
        }),
        new ReportTableData<string>({
            colId: CryptoDepositAddressAccountCurrencySelector,
            value: null,
            hidden: false,
            valueClass: 'account-currency-pill'
        }),
        new ReportTableData<string>({
            colId: CryptoDepositAddressTypeSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: CryptoDepositAddressCurrencySelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: CryptoDepositAddressNetworkSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: CryptoDepositAddressDepositAddressSelector,
            value: null,
            hidden: false,
            class: 'deposit-address-cell',
            valueClass: 'deposit-address-cell__text',
            isClickable: true,
            actionTitle: 'Copy deposit address'
        })
    ];
};

export const PanelClientsEditCryptoDepositAddressesDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Account ID',
                selector: CryptoDepositAddressAccountIdSelector
            }),
            new ReportTableColumn({
                label: 'Acc Currency',
                selector: CryptoDepositAddressAccountCurrencySelector
            }),
            new ReportTableColumn({
                label: 'Type',
                selector: CryptoDepositAddressTypeSelector
            }),
            new ReportTableColumn({
                label: 'Currency',
                selector: CryptoDepositAddressCurrencySelector
            }),
            new ReportTableColumn({
                label: 'Network',
                selector: CryptoDepositAddressNetworkSelector
            }),
            new ReportTableColumn({
                label: 'Deposit Address',
                selector: CryptoDepositAddressDepositAddressSelector
            }),
        ],
        hiddenColumnIds: [],
        actionMenu: false,
        actionMenuType: ReportTableActionMenuTypesEnum.Buttons,
        actionMenuItems: [],
        disableColumnsOptions: true
    };
};
